import React from "react";
import UniversalAuditTool from "../components/UniversalAuditTool";

export default function UniversalRiskAudit() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-white">
      {/* Top chrome */}
      <header className="border-b border-slate-200/70 bg-white/70 backdrop-blur">
        <div className="mx-auto max-w-7xl px-5 py-6">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <div className="text-[11px] font-black uppercase tracking-[0.35em] text-slate-500">
                AI Fine Protector
              </div>

              <div className="mt-2 flex flex-wrap items-center gap-2">
                <h1 className="text-2xl md:text-3xl font-black tracking-tight text-slate-900">
                  Universal Risk Audit
                </h1>
                <span className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-black text-slate-700">
                  Free Executive Preview
                </span>
              </div>

              <p className="mt-2 max-w-3xl text-sm text-slate-600">
                Estimate potential AI-related fine exposure across major regimes in seconds. This preview is designed for
                governance decision-making — not legal advice.
              </p>
            </div>

            <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3">
              <div className="text-[10px] font-black uppercase tracking-[0.25em] text-amber-900">
                Important
              </div>
              <div className="mt-1 text-xs text-amber-950">
                You must acknowledge the disclaimer before calculating exposure.
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main */}
      <main className="mx-auto max-w-7xl px-5 py-8">
        <UniversalAuditTool />
      </main>

      {/* Footer spacing */}
      <div className="h-10" />
    </div>
  );
}
